import React, { useState } from 'react';

import CompactNavigationSidebar from '@features/navigation/CompactNavigationSidebar';
import StickyNavigationSidebar from '@features/navigation/StickyNavigationSidebar';

const NavigationSidebar = () => {
  const [isNavigationSidebarCollapsed, _setIsNavigationSidebarCollapsed] = useState(false);
  return (
    <div data-testid="navigation-sidebar">
      {isNavigationSidebarCollapsed ? <CompactNavigationSidebar /> : <StickyNavigationSidebar />}
    </div>
  );
};

export default React.memo(NavigationSidebar);
